import { styled } from 'stitches.config'

const center = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

export const ThePackRoot = styled('div', {
  background: '$primary-700',
  paddingTop: '$6',
  paddingBottom: '$3',
  overflow: 'hidden',
  position: 'relative',

  '& .hide': {
    display: 'none',
  },

  '& .desktop-only': {
    display: 'none',
  },
  '& .mobile-only': {
    display: 'block',
  },

  '@bp2': {
    paddingTop: '$4',
    paddingBottom: '$4',
    '& .desktop-only': {
      display: 'flex',
    },
    '& .mobile-only': {
      display: 'none',
    },
  },
})

export const SliderContainer = styled('div', {
  display: 'block',
  margin: 'auto',
  textAlign: 'center',
  paddingTop: '$4',
  paddingBottom: '$4',
})

export const ImageGrid = styled('div', {
  ...center,
  flexDirection: 'row',
  gap: '$2',
  padding: '$7 $4 $8 $4',
  maxWidth: '1320px',
  margin: 'auto',
})

export const ImageWrapper = styled('div', {
  ...center,
  width: '100%',
  aspectRatio: '1 / 1',
  position: 'relative',
  maxWidth: '323px',
  margin: 'auto',
  '@bp2': {
    margin: 0,
    maxWidth: '338px',
  },
})

export const Header = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '$2',
  maxWidth: '300px',
  margin: 'auto',

  '@bp2': {
    maxWidth: '100%',
  },
})

export const InstaWrapper = styled('div', {
  ...center,
  paddingTop: '$2',
})
